var cov_1ftedz4roq = function () {
  var path = '/opt/lampp/htdocs/www/omcg/apps/delta-monitoring/client/src/app/views/analytics/custom_report/analyticsCustomReportCtrl.js',
      hash = 'c31cfe3e24cc4ac220f697868d1e5941b150aa75',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/opt/lampp/htdocs/www/omcg/apps/delta-monitoring/client/src/app/views/analytics/custom_report/analyticsCustomReportCtrl.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 1,
          column: 76
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 1,
            column: 62
          },
          end: {
            line: 1,
            column: 63
          }
        },
        loc: {
          start: {
            line: 1,
            column: 72
          },
          end: {
            line: 1,
            column: 74
          }
        },
        line: 1
      }
    },
    branchMap: {},
    s: {
      '0': 0
    },
    f: {
      '0': 0
    },
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_1ftedz4roq.s[0]++;
angular.module('app').controller('analyticsCustomReportCtrl', function ($scope) {
  cov_1ftedz4roq.f[0]++;
});